import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";
import { API } from "../../../setup/setupAxios";

export default function Dashboard() {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [monthly, setMonthly] = useState([]);
  const [yearly, setYearly] = useState([]);
  const [summary, setSummary] = useState({ customer: 0, goods: 0 });
  const [clock, setClock] = useState("");
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const jam = now.toLocaleTimeString("id-ID", { hour12: false });
      const tanggal = now.toLocaleDateString("id-ID");
      setClock(`${tanggal} ${jam}`);
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const handleNavigation = (event) => {
      if (localStorage.getItem("isLoggedIn")) {
        event.preventDefault();
      }
    };
    window.addEventListener("popstate", handleNavigation);
    return () => window.removeEventListener("popstate", handleNavigation);
  }, []);
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (localStorage.getItem("isLoggedIn")) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);
  useEffect(() => {
    async function load() {
      try {
        const [cust, goods] = await Promise.all([
          API("/api/customer"),
          API("/api/barang"),
        ]);

        const customers = cust.data.data;
        const barang = goods.data.data;

        setSummary({
          customer: customers.length,
          goods: barang.length,
        });

        const currentYear = new Date().getFullYear();
        const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

        const monthlyData = months.map((m, idx) => {
          const c = customers.filter((x) => {
            const d = new Date(x.createdAt);
            return d.getFullYear() === currentYear && d.getMonth() === idx;
          }).length;

          const g = barang.filter((x) => {
            const d = new Date(x.createdAt);
            return d.getFullYear() === currentYear && d.getMonth() === idx;
          }).length;

          return { month: m, customer: c, goods: g };
        });

        const last3Years = [2023, 2024, 2025];
        const yearlyData = last3Years.map((year) => ({
          year,
          customer: customers.filter((x) => new Date(x.createdAt).getFullYear() === year).length,
          goods: barang.filter((x) => new Date(x.createdAt).getFullYear() === year).length,
        }));

        setMonthly(monthlyData);
        setYearly(yearlyData);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }
    load();
  }, []);
  if (loading) return <div className="p-6">Loading...</div>;
  const BAR_CUSTOMER = "#4F46E5";
  const BAR_GOODS = "#16A34A";
  const PIE_COLORS = ["#4F46E5", "#16A34A"];

  return (
    <div className="fitur-all">
    <div className="p-6">
      <div className="text-right text-lg font-semibold mb-4">
        ⏱️ {clock}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 rounded-2xl shadow bg-white">
          <h2 className="text-xl font-semibold mb-4">Data Bulanan</h2>
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={monthly} style={{ background: "#fff", borderRadius: "12px" }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="customer" fill={BAR_CUSTOMER} />
              <Bar dataKey="goods" fill={BAR_GOODS} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="p-4 rounded-2xl shadow bg-white">
          <h2 className="text-xl font-semibold mb-4">Persentase Data Customer & Barang</h2>
          <ResponsiveContainer width="100%" height={350}>
            <PieChart>
              <Pie
                data={[
                  { name: "Customer", value: summary.customer },
                  { name: "Barang", value: summary.goods },
                ]}
                cx="50%"
                cy="50%"
                outerRadius={120}
                label
                dataKey="value"
              >
                { [summary.customer, summary.goods].map((_, idx) => (
                  <Cell key={idx} fill={PIE_COLORS[idx]} />
                ))}
              </Pie>
              <Legend />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="p-4 rounded-2xl shadow bg-white">
          <h2 className="text-xl font-semibold mb-4">Data 3 Tahun Terakhir</h2>
          <ResponsiveContainer width="100%" height={350}>
            <LineChart data={yearly} style={{ background: "#fff", borderRadius: "12px" }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="year" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line dataKey="customer" stroke={BAR_CUSTOMER} strokeWidth={3} />
              <Line dataKey="goods" stroke={BAR_GOODS} strokeWidth={3} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
    </div>
  );
}